export const DOCTOR_SEARCH_IGNORED_FILTERS = ['has_active_special_release_form']
